import { DateTime } from "@bps/date-time";

const asVariableMap = (value: any): Record<string, any> => {
  return value && typeof value === "object" && !Array.isArray(value)
    ? value
    : {};
};

const asResponseMap = (value: any): Record<string, any> => {
  if (!value) {
    return {};
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return asVariableMap(parsed);
    } catch {
      return {};
    }
  }

  return asVariableMap(value);
};

const toLocalDateTime = (value?: DateTime): string | undefined => {
  if (!value) {
    return undefined;
  }

  return value.toFormat("dd/MM/yyyy hh:mm a");
};

export { asVariableMap, asResponseMap, toLocalDateTime };
